const Cart = () => {
  return {
    cart: null,

    isChangingCart: false,

    isLoadingCart: false,

    isLoading() {
      return this.isLoadingCart;
    },

    async init() {
      await this.getCart();
    },

    async getCart() {
      try {
        this.isLoadingCart = true;
        const response = await fetch('/cart.js');
        const cart = await response.json();
        this.cart = cart;
        this.isLoadingCart = false;
      } catch (err) {
        console.error(err);
        this.isLoadingCart = false;
      }
    },

    async addToCart(items) {
      try {
        const formData = {
          items,
        };

        await fetch('/cart/add.js', {
          body: JSON.stringify(formData),
          headers: {
            'Content-Type': 'application/json',
          },
          method: 'POST',
        });

        await this.getCart();
      } catch (err) {
        console.error(err);
      }
    },

    // refetch() {
    //   this.lock = true;
    //   fetch('/cart.js')
    //     .then((response) => response.json())
    //     .then((cart) => {
    //       this.cart = cart;
    //       this.lock = false;
    //
    //       return Promise.all(cart.items.map((x) => fetch(`/products/${x.handle}.js`)));
    //     })
    //     // .then(xs => Promise.all(xs.map(x => x.json())))
    //     // .then(xs => {
    //     //   const variants = xs
    //     //     .flatMap(xs => xs.variants)
    //     //     .reduce((acc, x) => {
    //     //       return {
    //     //         ...acc,
    //     //         [x.id]: x
    //     //       }
    //     //     }, {})
    //     //
    //     //   this.cart.variants = variants;
    //     // })
    //     .catch((err) => {
    //       console.error(err);
    //       this.lock = false;
    //     });
    // },

    async changeCart({ line, quantity }) {
      try {
        this.isChangingCart = true;

        const formData = {
          line,
          quantity,
        };

        await fetch('/cart/change.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify(formData),
        });

        await this.getCart();

        this.isChangingCart = false;
      } catch (err) {
        console.error(err);
      }
    },

    updateCart({ key, quantity }) {
      this.lock = true;

      const url = `${window.Shopify.routes.root}cart/update.js`;

      const formData = {
        updates: {
          [key]: quantity,
        },
      };

      fetch(url, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(formData),
      })
        .then((_x) => this.getCart())
        .catch((err) => console.error(err));
    },
  };
};

export default Cart;
